import ApiClient from "./ApiClient";
import Selectitem from "../models/shared/SelectItem";
import { CompanionInPublicTransportType } from "../models/companion-transport-types/CompanionInPublicTransportType";

export default class TransportOptionTypeApiClient {
  apiClient: ApiClient;
  urlPrefix: string = "companion-transport-types/";

  constructor() {
    this.apiClient = new ApiClient();
  }

  async getCompanionTransportTypes() {
    const companionTransportTypes = await this.apiClient.get(this.urlPrefix);

    return <Selectitem<CompanionInPublicTransportType>[]>(
      companionTransportTypes
    );
  }
}
